<template>
  <modal name="manageEmailModal" id="manageEmailModal" class="custom-modal" :width="'75%'" :height="'auto'"
            :scrollable="true" :pivotX="1.0" :minWidth="900" :minHeight="900" @before-open="beforeOpen" @before-close="beforeClose" @opened="opened"
            :clickToClose="true" >
    <div class="client-contact-email-page">
      <div class="header-email-page">
        <p>Email Client</p>
        <div class="icon-close" @click="cancelClick()"></div>
      </div>
      <div>
        <ClientContactEmail
          :eventId="eventId"
          :event="event"
          :singleEvent="singleEvent"
          :isChange="isChange"
          :emailTemplateType="emailTemplateType"
          :replyEmail="replyEmail"
          :listEmailCC="listEmailCC"
          :listEmailSendTo="listEmailSendTo"
          :body="body"
          :cancelClick="cancelClick"
          :backToPreviousPage="backToPreviousPage"
        />
      </div>
      <ModalInfo @CLOSE_MODAL_INFO="closeModalCancelEmail"/>
    </div>
  </modal>
</template>

<script>
  import VueSlider from 'vue-slider-component';
  import ClientContactEmail from '@/components/events/ClientContactEmail';
  import ModalInfo from '@/components/modal/ModalInfo';
  import {mapActions} from 'vuex';
  import emailTemplateConsts from '@/store/constants/emailTemplateType';
  import consts from '../../_consts';

  export default {
    name: 'Client-Manage-Email-Page',
    components: {
      VueSlider,
      ClientContactEmail,
      ModalInfo
    },
    data () {
      return {
        emailType: {
          value: ['0', '0'],
          width: '182px',
          tooltip: false,
          disabled: false,
          piecewise: true,
          piecewiseLabel: true,
          dotSize: 8,
          interval: 7,
          formatter: '{value}',
          overlapFormatter: '{value1} ~ {value2}',
          data: [
            '0',
            '7',
            '30',
            '60'
          ],
          piecewiseStyle: {
            backgroundColor: 'transparent',
            visibility: 'visible',
            width: '15px',
            height: '15px'
          },
          piecewiseActiveStyle: {
            backgroundColor: '#00A4D6'
          },
          processStyle: {
            backgroundColor: '#00A4D6'
          }
        },
        eventId: null,
        event: {
          relatedEvents: []
        },
        emailTemplateType: emailTemplateConsts.day60,
        singleEvent: true,
        listEmailSendTo: [],
        listEmailCC: [],
        replyEmail: '',
        body: '',
        isManageDetails: false,
        isChange: false
      };
    },
    methods: {
      beforeOpen (params) {
        if (params.params && params.params.eventId) {
          this.eventId = params.params.eventId;
          this.isManageDetails = params.params.isManageDetails;
          this.getEventById(params.params.eventId).then(response => {
            if (response.message === null) {
              this.event = {...response.event, relatedEvents: response.event.relatedEvents.filter(x => x.status.toLowerCase() !== consts.eventStatus.archived)};
            }
          });
        }
        this.$bus.$on('changeEditor', this.changeIsEditor);
      },
      beforeClose () {
        this.eventId = null;
        this.event = { relatedEvents: [] };
        this.emailTemplateType = emailTemplateConsts.day60;
        this.replyEmail = '';
        this.listEmailSendTo = [];
        this.listEmailCC = [];
      },
      opened () {
        this.updateNextZIndex('manageEmailModal');
      },
      changeIsEditor () {
        this.isChange = true;
      },
      closeModalCancelEmail (isCancelEmail) {
        if (isCancelEmail) {
          this.backToPreviousPage();
        }
      },
      backToPreviousPage () {
        if (this.isManageDetails) {
          this.$modal.hide('manageEmailModal');
          return;
        }
        this.$router.push({name: 'ManageApprovedDashboard', params: {eventId: this.eventId, textSearch: localStorage.getItem(consts.LOCAL_STORE.searchEventString), filter: localStorage.getItem(consts.LOCAL_STORE.filterEventString), sort: localStorage.getItem(consts.LOCAL_STORE.sortEventString), dateSliderValue: localStorage.getItem(consts.LOCAL_STORE.dateRangeEvent)}});
      },
      cancelClick () {
        let modalData = {
          action: consts.modalAction.modalCancelEmail,
          data: null
        };
        if (this.isChange) {
          this.$modal.show('modalInfo', modalData);
        } else {
          if (this.isManageDetails) {
            this.$modal.hide('manageEmailModal');
            return;
          }
          this.$router.push({name: 'ManageApprovedDashboard', params: {eventId: this.eventId, textSearch: localStorage.getItem(consts.LOCAL_STORE.searchEventString), filter: localStorage.getItem(consts.LOCAL_STORE.filterEventString), sort: localStorage.getItem(consts.LOCAL_STORE.sortEventString), dateSliderValue: localStorage.getItem(consts.LOCAL_STORE.dateRangeEvent)}});
        }
      },
      ...mapActions({
        getEventById: 'ACTION_GET_EVENT_BY_ID',
        getDefaultEmailTemplate: 'ACTION_GET_DEFAULT_EMAIL_TEMPLATE',
        updateNextZIndex: 'ACTION_UPDATE_NEXT_ZINDEX'
      })
    },
    mounted () {}
};
</script>

<style lang="less">
  @import '../../styles/variables.less';
</style>




// WEBPACK FOOTER //
// ManageEmail.vue?654aadfa